import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { SignUpImage } from "../../../../assets";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/reducers/userSlice";
import "./style.css";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import { RegistrationVS } from "../../../util/validation";
import { toastMessage } from "../../../components/common/toast";
import { RegisterUser, RequestUser } from "../../../services/authService";

function SignupModal({ openModal, HideModal, address }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isPublisher, setPublisher] = useState(false);
  const initialValues = {
    email: "",
    password: "",
    username: "",
    role: "",
    firstname: "",
    lastname: "",
    officeAddress: "",
    phonenumber: "",
  };

  const handleSignUp = async (values, action) => {
    let obj1 = {};
    let obj2 = {};
    if (address) {
      obj1["username"] = values.username;
      obj2["username"] = values.username;
      obj1["email"] = values.email;
      obj2["email"] = values.email;
      obj1["password"] = values.password;
      obj2["password"] = values.password;
      obj1["type"] = values.role;
      if (values.role === "publisher") {
        obj2["phonenumber"] = values.phonenumber;
        obj2["address"] = values.officeAddress;
      }
      obj1["firstname"] = values.firstname;
      obj2["firstname"] = values.firstname;
      obj1["lastname"] = values.lastname;
      obj2["lastname"] = values.lastname;
      obj1["walletaddress"] = String(address);
      obj2["walletaddress"] = String(address);
      obj1["status"] = 1;
    }
    if (values.role === "publisher") {
      await RequestUser(obj2)
        .then((res) => {
          if (res.statusText === "OK") {
            action.setSubmitting(false);
            setPublisher(false);
            toastMessage("Account Request Generated Successfully", "success");
            HideModal();
          } else {
            action.setSubmitting(false);
            toastMessage(res.data, "error");
          }
        })
        .catch((err) => {
          action.setSubmitting(false);
          toastMessage(
            err?.response?.data?.message
              ? err.response.data.message
              : "Check your Network Connection",
            "error"
          );
        });
    } else {
      await RegisterUser(obj1)
        .then((res) => {
          if (res.statusText === "OK") {
            let resp = {
              isLoggedIn: true,
              user: res.data.user,
              token: res.data.token,
              books: 0,
            };
            dispatch(setUser(resp));
            action.setSubmitting(false);
            history.push(`/home/${res?.data?.user?._id}`);
            setPublisher(false);
            toastMessage("User Registered Successfully", "success");
            HideModal();
          } else {
            action.setSubmitting(false);
            toastMessage(res.data, "error");
          }
        })
        .catch((err) => {
          action.setSubmitting(false);
          toastMessage(
            err?.response?.data?.message
              ? err.response.data.message
              : "Check your Network Connection",
            "error"
          );
        });
    }
  };
  const AddExtrafields = () => setPublisher(true);
  const CloseModal = () => {
    setPublisher(false);
    HideModal();
  };
  const RemoveExtrafields = () => {
    setPublisher(false);
  };
  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onHide={HideModal}
      centered
    >
      <button
        type="button"
        className="close custom-modal-close"
        onClick={CloseModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="modal-body modal-body-flex">
        <div className="login-bg">
          <img
            src={SignUpImage}
            alt="register-modal"
            className="signup-image"
          />
        </div>
        <div className="signup-login-form">
          <p className="signup-heading">Create your DigiBook Account</p>
          <div className="address-container">
            <p className="address-heading">ADDRESS</p>
            <p className="address">{address}</p>
          </div>
          <Formik
            initialValues={initialValues}
            onSubmit={(values, action) => {
              console.log("Here");
              action.setSubmitting(true);
              handleSignUp(values, action);
            }}
            validationSchema={RegistrationVS}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <div className="formik-container">
                <div className="signup-dual-input-container">
                  <div className="signup-input-container">
                    <input
                      type="text"
                      placeholder="firstname*"
                      onChange={handleChange("firstname")}
                      value={values.firstname}
                      className="input-value"
                    />
                    <div className="error">
                      {touched.firstname && errors.firstname
                        ? errors.firstname
                        : ""}
                    </div>
                  </div>
                  <div className="empty" />
                  <div className="signup-input-container">
                    <input
                      type="text"
                      placeholder="lastname*"
                      onChange={handleChange("lastname")}
                      value={values.lastname}
                      className="input-value"
                    />
                    <div className="error">
                      {touched.lastname && errors.lastname
                        ? errors.lastname
                        : ""}
                    </div>
                  </div>
                </div>

                <div className="signup-input-container">
                  <input
                    type="text"
                    placeholder="username*"
                    onChange={handleChange("username")}
                    value={values.username}
                    className="input-value"
                  />
                  <div className="error">
                    {touched.username && errors.username ? errors.username : ""}
                  </div>
                </div>

                <div className="signup-input-container">
                  <input
                    type="text"
                    placeholder="email*"
                    onChange={handleChange("email")}
                    value={values.email}
                    className="input-value"
                  />
                  <div className="error">
                    {touched.email && errors.email ? errors.email : ""}
                  </div>
                </div>
                <div className="signup-input-container">
                  <input
                    type="password"
                    placeholder="password*"
                    onChange={handleChange("password")}
                    value={values.password}
                    className="input-value"
                  />
                  <div className="error">
                    {touched.password && errors.password ? errors.password : ""}
                  </div>
                </div>

                <div className="left">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="bookreader"
                      onChange={(e) => {
                        setFieldValue("role", e.target.value);
                        setFieldValue("isPublisher", false);
                      }}
                      onClick={RemoveExtrafields}
                    />
                    <label class="form-check-label" for="inlineRadio1">
                      Book Reader
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="publisher"
                      onChange={(e) => {
                        setFieldValue("role", e.target.value);
                        setFieldValue("isPublisher", true);
                      }}
                      onClick={AddExtrafields}
                    />
                    <label class="form-check-label" for="inlineRadio2">
                      Publisher
                    </label>
                  </div>
                  <div className="error2">
                    {touched.role && errors.role ? errors.role : ""}
                  </div>
                </div>
                {isPublisher ? (
                  <>
                    <div className="signup-input-container">
                      <input
                        type="text"
                        placeholder="phone number*"
                        onChange={handleChange("phonenumber")}
                        value={values.phonenumber}
                        className="input-value"
                      />
                      <div className="error">
                        {touched.phonenumber && errors.phonenumber
                          ? errors.phonenumber
                          : ""}
                      </div>
                    </div>

                    <div className="signup-input-container">
                      <input
                        type="text"
                        placeholder="address*"
                        onChange={handleChange("officeAddress")}
                        value={values.officeAddress}
                        className="input-value"
                      />
                      <div className="error">
                        {touched.officeAddress && errors.officeAddress
                          ? errors.officeAddress
                          : ""}
                      </div>
                    </div>
                  </>
                ) : null}
                <button
                  type="submit"
                  className="signup-button mt-3"
                  onClick={handleSubmit}
                >
                  {isSubmitting ? (
                    <Spinner animation="grow" size="sm" />
                  ) : (
                    <p className="mb-0">Sign up</p>
                  )}
                </button>
              </div>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
}

export default SignupModal;
